// extracted by mini-css-extract-plugin
export default {"setupFormSubmitButton":"SetupForm_setupFormSubmitButton__z1z4-","setupFormLoader":"SetupForm_setupFormLoader__1UYPp"};